<template>
  <v-dialog
    v-model="show"
    width="60vw"
    :fullscreen="$vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly"
    scrollable
    persistent
  >
    <v-card
      height="auto"
      elevation="0"
      class="rounded-lg"
      min-height="200"
      v-if="loteSelected"
    >
      <v-card-title class="text-h5 lighten-2" v-if="loteSelected">
        <v-row no-gutters>
          <v-col cols="12"> Actualizar lote {{ loteSelected.loteId }} </v-col>
          <v-col cols="12">
            <span class="text-subtitle-1"
              > {{ loteSelected.identificationName }}</span
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <div>
            <v-row
              v-if="
                loteSelected.productionState !== 'USELESS' &&
                loteSelected.productionState !== 'DISCARDED'
              "
            >
              <v-col align="end">
                <v-btn
                  small
                  rounded
                  color="warning"
                  dark
                  @click="showDiscardLoteModal = true"
                >
                  <v-icon>mdi-delete-variant</v-icon>
                  Desechar lote
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-stepper v-model="stepper" vertical non-linear elevation="0">
            <v-stepper-step
              step="1"
              editable
              :complete="loteSelected.productionState != 'PREINOCULATE'"
            >
              Preinóculo</v-stepper-step
            >
            <v-stepper-content step="1">
              <v-container fluid>
                <v-form ref="formPreinoculate" lazy-validation>
                  <v-row no-gutters>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.preinoculateStartDate"
                        type="date"
                        outlined
                        clearable
                        label="Introduce fecha de inicio"
                        dense
                        :disabled="
                          loteSelected.endPreinoculateDate ? true : false
                        "
                        :rules="validation('Fecha')"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.flaskQtyStart"
                        type="number"
                        outlined
                        clearable
                        label="Número de matraces inoculados"
                        dense
                        :disabled="
                          loteSelected.endPreinoculateDate ? true : false
                        "
                        :rules="validationNumber('Matraces')"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    justify="end"
                    v-if="!(loteSelected.endPreinoculateDate ? true : false)"
                  >
                    <v-col cols="12" xl="6" lg="6">
                      <v-btn
                        color="primary"
                        dark
                        block
                        @click="saveDataPreinoculateRequest"
                      >
                        Pasar a validación de preinóculo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row v-if="loteSelected.endPreinoculateDate">
                  <v-col>
                    <v-row>
                      <v-col v-if="loteSelected.isValidationPreinoculate">
                        <v-icon color="primary" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        <span>Preinóculo validaciones finalizadas.</span>
                      </v-col>
                      <v-col v-else>
                        <v-progress-circular
                          class="mr-2"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <span>Preinóculo validaciones en proceso...</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="2"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED'
              "
              v-if="
                loteSelected.dosesStart > 1 && loteSelected.endPreinoculateDate
              "
            >
              Inóculo</v-stepper-step
            >
            <v-stepper-content step="2">
              <v-container fluid>
                <v-row class="text-end py-2">
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="loteSelected.endInoculateeDate ? true : false"
                      @click="showUndoPreinoculateConfirmation = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Regresar a preinóculo
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="formInoculate" lazy-validation>
                  <v-row no-gutters>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.inoculateDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de pase"
                        dense
                        :disabled="
                          loteSelected.endInoculateeDate ? true : false
                        "
                        :rules="validation('Fecha')"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.jarsQty"
                        type="number"
                        outlined
                        clearable
                        label="Número de frascos inoculados"
                        dense
                        :disabled="
                          loteSelected.endInoculateeDate ? true : false
                        "
                        :rules="validationNumber('Matraces')"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    justify="end"
                    v-if="!(loteSelected.endInoculateeDate ? true : false)"
                  >
                    <v-col cols="12" xl="6" lg="6">
                      <v-btn color="primary" dark block @click="goToInoculate">
                        Pasar a validación de inóculo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row v-if="loteSelected.endInoculateeDate ? true : false">
                  <v-col>
                    <v-row>
                      <v-col v-if="loteSelected.isStartedInoculate">
                        <v-icon color="primary" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        <span>Inóculo validaciónes finalizadas.</span>
                      </v-col>
                      <v-col v-else>
                        <v-progress-circular
                          class="mr-2"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <span>Inóculo validaciónes en proceso...</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="3"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED' &&
                loteSelected.productionState != 'SEED'
              "
              v-if="loteSelected.endInoculateeDate"
            >
              Semilla</v-stepper-step
            >
            <v-stepper-content step="3">
              <v-container fluid>
                <v-row class="text-end py-2">
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="loteSelected.isStartedSeed"
                      @click="showUndoInoculateConfirmation = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Regresar a inóculo
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="formSeedStart" lazy-validation>
                  <v-row no-gutters>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.seedDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de pase"
                        dense
                        :disabled="loteSelected.isStartedSeed"
                        :rules="validation('Fecha')"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      <v-text-field
                        v-model="loteSelected.jarsSeedQty"
                        type="number"
                        outlined
                        clearable
                        label="Número de frascos inoculados"
                        dense
                        :disabled="loteSelected.isStartedSeed"
                        :rules="validationNumber('Matraces')"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" class="pa-1">
                      Tipo de frasco: BB13
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    justify="end"
                    v-if="!loteSelected.isStartedSeed"
                  >
                    <v-col cols="12" xl="5" lg="5">
                      <v-btn
                        color="primary"
                        dark
                        block
                        @click="startSeedRequest"
                      >
                        Pasar a validación semilla
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <div v-if="loteSelected.isStartedSeed">
                  <div>
                    <v-row>
                      <v-col v-if="loteSelected.endSeedValidations">
                        <v-icon color="primary" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        <span>Semilla validaciones finalizadas.</span>
                      </v-col>
                      <v-col v-else>
                        <v-progress-circular
                          class="mr-2"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <span>Semilla validaciones en proceso...</span>
                      </v-col>
                    </v-row>
                  </div>
                </div>
                <div v-if="loteSelected.isStartedSeed" class="mt-5">
                  <v-row class="text-end py-2">
                    <v-col>
                      <v-btn
                        small
                        color="primary"
                        :disabled="!!loteSelected.endSeedDate"
                        @click="showUndoPreSeedValidation = true"
                      >
                        <v-icon>mdi-undo</v-icon>
                        Regresar a paso anterior
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-form ref="formSeedEnd" lazy-validation>
                        <v-row>
                          <v-col cols="12" xl="6" lg="6">
                            <v-combobox
                              v-model="loteSelected.productionType"
                              :items="productionTypes"
                              label="Selecciona tipo de producción"
                              item-text="text"
                              outlined
                              dense
                              return-object
                              :rules="validation()"
                              :disabled="!!loteSelected.endSeedDate"
                            ></v-combobox>
                          </v-col>
                          <v-col
                            cols="12"
                            xl="6"
                            lg="6"
                            v-if="
                              loteSelected.productionType &&
                              loteSelected.productionType.value == 'reactor'
                            "
                          >
                            <v-combobox
                              v-model="loteSelected.reactor"
                              :items="reactors"
                              label="Selecciona reactor"
                              outlined
                              dense
                              return-object
                              :rules="validation()"
                              :disabled="
                                loteSelected.endSeedDate ? true : false
                              "
                            ></v-combobox>
                          </v-col>
                        </v-row>
                        <v-row
                          no-gutters
                          v-if="
                            loteSelected.productionType &&
                            loteSelected.productionType.value == 'reactor'
                          "
                        >
                          <v-col cols="12" class="text-start">
                            <span>¿Habrá realimentación?</span>
                          </v-col>
                          <v-col>
                            <v-radio-group
                              row
                              v-model="loteSelected.isFeedable"
                              :disabled="
                                loteSelected.endSeedDate ? true : false
                              "
                              :rules="[
                                (v) =>
                                  loteSelected.isFeedable != undefined ||
                                  `El campo es obligatorio.`,
                              ]"
                            >
                              <v-radio :value="true" label="Si"></v-radio>
                              <v-radio :value="false" label="No"></v-radio>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row
                          align="center"
                          justify="end"
                          v-if="loteSelected.endSeedDate ? false : true"
                        >
                          <v-col cols="12" xl="4" lg="4">
                            <v-btn
                              color="gray"
                              dark
                              block
                              @click="saveSeedFinalStageRequest"
                            >
                              Guardar
                            </v-btn>
                          </v-col>
                          <v-col cols="12" xl="4" lg="4">
                            <v-btn
                              color="primary"
                              dark
                              block
                              @click="finishSeedFinalStageRequest"
                              >Pasar a fermentación
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-stepper-content>

            <v-stepper-step
              step="4"
              editable
              :complete="
                loteSelected.productionState != 'PREINOCULATE' &&
                loteSelected.productionState != 'INOCULATED' &&
                loteSelected.productionState != 'SEED' &&
                loteSelected.productionState != 'FERMENTATION'
              "
              v-if="loteSelected.endSeedDate"
            >
              <span v-if="loteSelected.productionType.value == 'mr'">
                {{ loteSelected.productionType.text }}
              </span>
              <span v-else>
                Fermentación ({{ loteSelected.productionType.text }})
              </span>
            </v-stepper-step>
            <v-stepper-content step="4">
              <v-container
                v-if="
                  loteSelected.productionType &&
                  loteSelected.productionType.value == 'reactor'
                "
                fluid
                class="pa-0"
              >
                <v-row class="text-end py-2">
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="
                        loteSelected.isReadyToValidateFermentationReactorSimple
                      "
                      @click="showUndoSeed = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Regresar a Semilla
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="formReactorDates">
                  <v-row>
                    <v-col cols="12" xl="6" lg="6">
                      <v-text-field
                        v-model="loteSelected.reactorFlushDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de lavado de reactor"
                        dense
                        :rules="validation('Fecha')"
                        :disabled="
                          loteSelected.isReadyToValidateFermentationReactorSimple
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6">
                      <v-text-field
                        v-model="loteSelected.reactorSterilizationDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de esterilizado de reactor"
                        dense
                        :rules="validation('Fecha')"
                        :disabled="
                          loteSelected.isReadyToValidateFermentationReactorSimple
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6">
                      <v-text-field
                        v-model="loteSelected.reactorInoculationSeedDate"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de inoculación de reactor con semilla"
                        dense
                        :rules="validation('Fecha')"
                        :disabled="
                          loteSelected.isReadyToValidateFermentationReactorSimple
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6">
                      <v-text-field
                        v-model="loteSelected.reactorSterilization2Date"
                        type="date"
                        outlined
                        clearable
                        label="Fecha de la segunda esterilización del reactor (opcional)"
                        dense
                        :disabled="
                          loteSelected.isReadyToValidateFermentationReactorSimple
                        "
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row
                    align="center"
                    justify="end"
                    v-if="
                      !loteSelected.isReadyToValidateFermentationReactorSimple
                    "
                  >
                    <v-col cols="12" xl="4" lg="4">
                      <v-btn
                        color="gray"
                        dark
                        block
                        @click="saveFermentationReeactorSimpleRequest"
                      >
                        Guardar
                      </v-btn>
                    </v-col>
                    <v-col cols="12" xl="4" lg="4">
                      <v-btn
                        color="primary"
                        dark
                        block
                        @click="endFermentationReeactorSimpleRequest"
                        >Pasar a validación de Reactor
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row
                  v-if="loteSelected.isReadyToValidateFermentationReactorSimple"
                >
                  <v-col v-if="loteSelected.isEndTimeValidationReady">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso calidad finalizado.</span>
                    <v-row>
                      <v-col> </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En espera de calidad...</span>
                  </v-col>
                </v-row>
                <v-row
                  class="text-end py-2"
                  v-if="loteSelected.isReadyToValidateFermentationReactorSimple"
                >
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="loteSelected.isDoneFermentation"
                      @click="showUndoFermentationFirstStep = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Regresar a paso anterior
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form
                  lazy-validation
                  ref="form_finish_react_single"
                  v-if="
                    loteSelected.isReadyToValidateFermentationReactorSimple &&
                    !loteSelected.isFeedable
                  "
                >
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="loteSelected.initialPhReactor"
                        dense
                        outlined
                        label="Ingresa el pH inicial"
                        type="number"
                        :rules="[(v) => !!v || 'Campo requerido']"
                        :disabled="
                          !loteSelected.isEndTimeValidationReady ||
                          loteSelected.isDoneFermentation
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="loteSelected.endPhReactor"
                        dense
                        outlined
                        label="Ingresa el pH ajustado"
                        type="number"
                        :rules="[(v) => !!v || 'Campo requerido']"
                        :disabled="
                          !loteSelected.isEndTimeValidationReady ||
                          loteSelected.isDoneFermentation
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="loteSelected.mlAdjustmentReactor"
                        dense
                        outlined
                        label="Ingresa ml ajuste de pH"
                        type="number"
                        :rules="[(v) => !!v || 'Campo requerido']"
                        :disabled="
                          !loteSelected.isEndTimeValidationReady ||
                          loteSelected.isDoneFermentation
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        outlined
                        label="Fecha de envasado"
                        type="date"
                        v-model="loteSelected.packingDate"
                        :disabled="
                          !loteSelected.isEndTimeValidationReady ||
                          loteSelected.isDoneFermentation
                        "
                        :rules="[(v) => !!v || 'Campo requerido']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        dense
                        outlined
                        label="Número de bidones"
                        type="number"
                        v-model="loteSelected.drumsQty"
                        :disabled="
                          !loteSelected.isEndTimeValidationReady ||
                          loteSelected.isDoneFermentation
                        "
                        :rules="[(v) => !!v || 'Campo requerido']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row
                  justify="end"
                  v-if="
                    loteSelected.isReadyToValidateFermentationReactorSimple &&
                    !loteSelected.isDoneFermentation
                  "
                >
                  <v-col cols="auto" v-if="!loteSelected.isFeedable">
                    <v-btn color="warning" block @click="goToFeedableRequest">
                      Pasar a realimentaciones
                    </v-btn>
                  </v-col>
                  <v-col cols="auto" v-if="!loteSelected.isFeedable">
                    <v-btn
                      color="gray"
                      block
                      dark
                      @click="handleFinishLoteSave"
                    >
                      Guardar
                    </v-btn>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      block
                      @click="finishLoteRequest"
                      :disabled="!loteSelected.isEndTimeValidationReady"
                    >
                      {{
                        loteSelected.isFeedable
                          ? "Pasar a realimentaciones"
                          : "Finalizar lote"
                      }}
                    </v-btn>
                  </v-col>
                </v-row>
                <div
                  v-if="
                    loteSelected.isDoneFermentation && loteSelected.isFeedable
                  "
                  class="pt-5"
                >
                  <v-divider></v-divider>
                  <div v-if="!refeed">
                    <v-row class="pt-5">
                      <v-col>
                        <span class="text-h6">
                          Realimentaciones en reactor
                        </span>
                      </v-col>
                    </v-row>
                    <v-row class="py-3">
                      <v-col>
                        <v-btn
                          color="primary"
                          rounded
                          :disabled="loteSelected.productionState == 'STOCK_PT'"
                          @click="addRefeedRequest"
                        >
                          <v-icon> mdi-seed-plus </v-icon>
                          Agregar registro
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-data-table
                          fixed-header
                          height="auto"
                          :headers="headersRefeed"
                          :items="refeeds"
                          no-data-text="No hay realimentaciones"
                          loading-text="Cargando realimentaciones..."
                          hide-default-footer
                        >
                          <template #[`item.serial`]="{ item }">
                            <span v-if="item.serial == 1" class="text-caption">
                              Primer inoculación
                            </span>
                            <span v-else class="text-caption">
                              Realimentación {{ item.serial - 1 }}
                            </span>
                            <span
                              v-if="item.validations.isApproved == false"
                              class="red--text"
                            >
                              (Descartado)
                            </span>
                          </template>
                          <template #[`item.inoculationDate`]="{ item }">
                            <span v-if="item.inoculationDate">
                              {{ item.inoculationDate }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template
                            #[`item.estimatedLitersInoculated`]="{ item }"
                          >
                            <span v-if="item.estimatedLitersInoculated">
                              {{ item.estimatedLitersInoculated }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.initialPh`]="{ item }">
                            <span v-if="item.initialPh">
                              {{ item.initialPh }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.adjustedPh`]="{ item }">
                            <span v-if="item.adjustedPh">
                              {{ item.adjustedPh }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.packingDate`]="{ item }">
                            <span v-if="item.packingDate">
                              {{ item.packingDate }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.litersPT`]="{ item }">
                            <span v-if="item.litersPT">
                              {{ item.litersPT }}
                            </span>
                            <span v-else>-</span>
                          </template>
                          <template #[`item.status`]="{ item }">
                            <span>
                              {{ getStatus(item.status) }}
                            </span>
                          </template>
                          <template #[`item.actions`]="{ item }">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  @click="setRefeed(item)"
                                  color="green"
                                  v-bind="attrs"
                                  v-on="on"
                                  v-if="
                                    item.validations.isApproved == true ||
                                    item.validations.isApproved == undefined
                                  "
                                >
                                  mdi-note-edit
                                </v-icon>
                              </template>
                              <span>Actualizar realimentación</span>
                            </v-tooltip>
                            <v-icon
                              v-if="item.validations.isApproved == false"
                              color="red"
                            >
                              mdi-close-octagon
                            </v-icon>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-row
                      justify="end"
                      v-if="loteSelected.productionState != 'STOCK_PT'"
                    >
                      <v-col cols="12" xl="4" lg="5">
                        <v-btn
                          color="primary"
                          rounded
                          @click="endFeedableRequest"
                          block
                        >
                          Finalizar lote
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <v-row class="pt-5">
                      <v-col>
                        <v-btn color="primary" rounded @click="unSetRefeed">
                          <v-icon> mdi-arrow-left </v-icon>
                          Regresar
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row class="pt-3">
                      <v-col>
                        <v-form ref="formRefeed">
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field
                                outlined
                                dense
                                label="Fecha de inoculación"
                                clearable
                                type="date"
                                v-model="refeed.inoculationDate"
                                :rules="validation()"
                                :disabled="refeed.isDoneFirstData"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :disabled="refeed.isDoneFirstData"
                                outlined
                                dense
                                label="Litros estimados inoculados"
                                clearable
                                type="number"
                                v-model="refeed.estimatedLitersInoculated"
                                :rules="validation()"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :disabled="refeed.isDoneFirstData"
                                outlined
                                dense
                                label="pH Inicial"
                                clearable
                                type="number"
                                v-model="refeed.initialPh"
                                :rules="validation()"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                :disabled="refeed.isDoneFirstData"
                                outlined
                                dense
                                label="ph Ajustado"
                                clearable
                                type="number"
                                v-model="refeed.adjustedPh"
                                :rules="validation()"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row justify="start" v-if="!refeed.isDoneFirstData">
                            <v-col cols="auto">
                              <v-btn
                                color="primary"
                                dark
                                block
                                @click="saveFeedableDataRequest(false)"
                              >
                                Guardar
                              </v-btn>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn
                                color="warning"
                                dark
                                block
                                @click="saveFeedableDataRequest(true)"
                              >
                                Continuar a validaciones
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                    <v-row v-if="refeed.isDoneFirstData">
                      <v-col v-if="refeed.isDoneValidations">
                        <v-icon color="primary" class="mr-2">
                          mdi-check-circle
                        </v-icon>
                        <span>Validación de realimentación finalizada.</span>
                      </v-col>
                      <v-col v-else>
                        <v-progress-circular
                          class="mr-2"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                        <span>Validación de realimentación en proceso...</span>
                      </v-col>
                    </v-row>
                    <div v-if="refeed.isDoneValidations" class="mt-5">
                      <v-form ref="packingFormRefeed">
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-text-field
                              outlined
                              dense
                              label="Fecha de envasado"
                              clearable
                              type="date"
                              v-model="refeed.packingDate"
                              :rules="validation()"
                              :disabled="refeed.isDone"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              :disabled="refeed.isDone"
                              outlined
                              dense
                              label="Litros envasados"
                              clearable
                              type="number"
                              v-model="refeed.litersPT"
                              :rules="validation()"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="!refeed.isDone">
                          <v-col class="text-end">
                            <v-btn
                              color="primary"
                              @click="saveFeedablePTRequest"
                              >Finalizar realimentación</v-btn
                            >
                          </v-col>
                        </v-row>
                      </v-form>
                    </div>
                  </div>
                </div>
              </v-container>
              <v-container
                v-if="
                  loteSelected.productionType &&
                  loteSelected.productionType.value == 'mr'
                "
              >
                <v-row class="text-end py-2">
                  <v-col>
                    <v-btn
                      small
                      color="primary"
                      :disabled="
                        loteSelected.isReadyToValidateFermentationReactorSimple
                      "
                      @click="showUndoSeed = true"
                    >
                      <v-icon>mdi-undo</v-icon>
                      Regresar a Semilla
                    </v-btn>
                  </v-col>
                </v-row>
                <v-form ref="form_first_rm" lazy-validation>
                  <v-row>
                    <v-col md="6">
                      <v-text-field
                        v-model="loteSelected.miniReactorStartDate"
                        dense
                        outlined
                        label="Fecha"
                        type="date"
                        :disabled="loteSelected.isDoneFlaskFirstStep"
                        :rules="validation()"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        v-model="loteSelected.miniReactorQuantity"
                        dense
                        outlined
                        label="Número de frascos"
                        type="number"
                        :disabled="loteSelected.isDoneFlaskFirstStep"
                        :rules="validation()"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" v-if="!loteSelected.isDoneFlaskFirstStep">
                      <v-row>
                        <v-col class="text-end">
                          <v-btn color="primary" @click="endMRFirstStep()">
                            Pasar a pH en frascos
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row v-if="loteSelected.isDoneFlaskFirstStep">
                  <v-col cols="12">
                    <span class="text-h6"> pH en frascos: </span>
                    <span
                      v-if="showInitialPhAdvice"
                      class="text-caption red--text"
                    >
                      (Recuerda ingresa el pH en todos los frascos)
                    </span>
                  </v-col>
                  <v-col cols="12">
                    <v-tabs v-model="currentMiniReactorTab" show-arrows>
                      <v-tab
                        v-for="(flask, index) in loteSelected.miniReactorFlasks"
                        :key="index"
                      >
                        {{ flask.name }}
                        <v-icon
                          v-if="flask.isContaminated"
                          small
                          color="error"
                          class="ml-1"
                        >
                          mdi-alert
                        </v-icon>
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="currentMiniReactorTab">
                      <v-tab-item
                        v-for="(flask, index) in loteSelected.miniReactorFlasks"
                        :key="index"
                      >
                        <v-container>
                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="flask.initialPh"
                                dense
                                outlined
                                label="Ingresa el pH inicial"
                                type="number"
                                :rules="[(v) => !!v || 'Campo requerido']"
                                :disabled="loteSelected.isDoneMRFirstStep"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="flask.endPh"
                                dense
                                outlined
                                label="Ingresa el pH ajustado"
                                type="number"
                                :rules="[(v) => !!v || 'Campo requerido']"
                                :disabled="loteSelected.isDoneMRFirstStep"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                v-model="flask.mlAdjustment"
                                dense
                                outlined
                                label="Ingresa ml ajuste de pH"
                                type="number"
                                :rules="[(v) => !!v || 'Campo requerido']"
                                :disabled="loteSelected.isDoneMRFirstStep"
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="gray"
                      dark
                      @click="savePhInitial(false)"
                      v-if="!loteSelected.isDoneMRFirstStep"
                    >
                      Guardar</v-btn
                    >
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      @click="savePhInitial(true)"
                      v-if="!loteSelected.isDoneMRFirstStep"
                    >
                      Pasar a validación de MR</v-btn
                    >
                  </v-col>
                </v-row>

                <v-row v-if="loteSelected.isDoneMRFirstStep">
                  <v-col cols="12">
                    <v-row class="text-end py-2">
                      <v-col>
                        <v-btn
                          small
                          color="primary"
                          :disabled="loteSelected.isDoneMRFirstStepValidations"
                          @click="showUndoMrFirstStep = true"
                        >
                          <v-icon>mdi-undo</v-icon>
                          Deshacer MR
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col v-if="loteSelected.isDoneMRFirstStepValidations">
                    <v-icon color="primary" class="mr-2">
                      mdi-check-circle
                    </v-icon>
                    <span>Proceso de validaciones finalizado.</span>
                  </v-col>
                  <v-col v-else>
                    <v-progress-circular
                      class="mr-2"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <span>En espera de calidad...</span>
                  </v-col>
                </v-row>

                <v-row
                  class="my-5"
                  v-if="loteSelected.isDoneMRFirstStepValidations"
                >
                  <v-col>
                    <span class="text-h6"> Datos de envasado: </span>
                  </v-col>
                </v-row>
                <v-form
                  lazy-validation
                  ref="form_finish_react_single"
                  v-if="loteSelected.isDoneMRFirstStepValidations"
                >
                  <v-row>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        label="Fecha de envasado"
                        type="date"
                        v-model="loteSelected.packingDate"
                        :disabled="loteSelected.isDoneFermentation"
                        :rules="[(v) => !!v || 'Campo requerido']"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6">
                      <v-text-field
                        dense
                        outlined
                        label="Número de bidones"
                        type="number"
                        v-model="loteSelected.drumsQty"
                        :disabled="loteSelected.isDoneFermentation"
                        :rules="[(v) => !!v || 'Campo requerido']"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row
                  v-if="loteSelected.isDoneMRFirstStepValidations"
                  class="justify-end"
                >
                  <v-col cols="auto">
                    <v-btn
                      color="primary"
                      block
                      @click="finishLoteRequest"
                      :disabled="loteSelected.isDoneFermentation"
                    >
                      Finalizar lote
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
          </v-stepper>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <GenericConfirmationModalDeleteLote
      v-model="showGenericConfirmationModalDeleteLote"
      @confirmation="confirmDeleteLote"
      :title="'¿Estás seguro que quieres elimnar lote por contaminación?'"
    />
    <DiscardLoteModal
      v-model="showDiscardLoteModal"
      @confirmation="dicardLote"
    />
    <UndoPreinoculateConfirmation
      v-model="showUndoPreinoculateConfirmation"
      @confirmation="handleUndoPreinoculate"
      :title="'¿Estás seguro que quieres regresar a Preinóculo?'"
    />
    <UndoInoculateConfirmation
      v-model="showUndoInoculateConfirmation"
      @confirmation="handleUndoInoculate"
      :title="'¿Estás seguro que quieres regresar a Inóculo?'"
    />
    <UndoPreSeedValidation
      v-model="showUndoPreSeedValidation"
      @confirmation="handlePreSeed"
      :title="'¿Estás seguro que quieres regresar al paso anterior?'"
    />
    <UndoSeed
      v-model="showUndoSeed"
      @confirmation="handleUndoSeed"
      :title="'¿Estás seguro que quieres regresar a Semilla?'"
    />
    <UndoMrFirstStep
      v-model="showUndoMrFirstStep"
      @confirmation="handleUndoMrFirstStep"
      :title="'¿Estás seguro que quieres deshacer MR?'"
    />
    <UndoFermentationFirstStep
      v-model="showUndoFermentationFirstStep"
      @confirmation="handleUndoEndFermentationReeactorSimple"
      :title="'¿Estás seguro que quieres deshacer el paso anterior?'"
    />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations } from "vuex";
//components
import Modal from "@/components/utils/GenericConfirmationModal.vue";
import GenericConfirmationModalDeleteLote from "@/components/dashboard/lote/modals/DeleteLoteModal.vue";
import DiscardLoteModal from "@/components/dashboard/lote/modals/DiscardLoteModal.vue";
import UndoPreinoculateConfirmation from "@/components/utils/GenericConfirmationModal.vue";
import UndoInoculateConfirmation from "@/components/utils/GenericConfirmationModal.vue";
import UndoPreSeedValidation from "@/components/utils/GenericConfirmationModal.vue";
import UndoSeed from "@/components/utils/GenericConfirmationModal.vue";
import UndoMrFirstStep from "@/components/utils/GenericConfirmationModal.vue";
import UndoFermentationFirstStep from "@/components/utils/GenericConfirmationModal.vue";
//validations d
import {
  requiredFValidation,
  requiredValidation,
  requiredMultiple,
  numberValidation,
} from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
export default {
  components: {
    Modal,
    GenericConfirmationModalDeleteLote,
    DiscardLoteModal,
    UndoPreinoculateConfirmation,
    UndoInoculateConfirmation,
    UndoPreSeedValidation,
    UndoSeed,
    UndoMrFirstStep,
    UndoFermentationFirstStep,
  },
  data: () => ({
    showUndoFermentationFirstStep: false,
    showGenericConfirmationModalDeleteLote: false,
    showMFAdviceInoculate: false,
    showAdviceMFPreinoculate: false,
    showAdviceMFSeed: false,
    showDiscardLoteModal: false,
    showUndoPreinoculateConfirmation: false,
    showUndoInoculateConfirmation: false,
    showUndoPreSeedValidation: false,
    showUndoSeed: false,
    showUndoMrFirstStep: false,
    user: JSON.parse(localStorage.getItem("user")),
    stepper: 1,
    panels1: null,
    contaminations: [
      { text: "Bacteria", value: "bacteria" },
      { text: "Hongo", value: "fungi" },
    ],
    flaskSelected2: null,
    jarSelected: null,
    jarSelectedSeed: null,
    jarSelectedSeedFeedable: null,
    sampleFermentation3L: null,
    sampleFermentation5L: null,
    validationStartTime: null,
    validationEndTime: null,
    packaged: [],
    page: 1,
    fetchingData: false,
    numPages: 1,
    staining: [
      { text: "Gram +", value: "positve" },
      { text: "Gram -", value: "negative" },
    ],
    seedJarTypes: ["BB13", "2L"],
    setPanel: 0,
    productionTypes: [
      // { text: "Bidón", value: "drum" },
      { text: "MR", value: "mr" },
      { text: "Reactor", value: "reactor" },
    ],
    reactors: ["reactor 1", "reactor 2"],
    headersRefeed: [
      {
        text: "Tipo",
        align: "center",
        value: "serial",
        sortable: false,
      },
      {
        text: "Fecha de inoculación",
        align: "center",
        value: "inoculationDate",
        sortable: false,
      },
      {
        text: "Litros estimados inoculados",
        align: "center",
        value: "estimatedLitersInoculated",
        sortable: false,
      },
      {
        text: "pH inicial",
        align: "center",
        value: "initialPh",
        sortable: false,
      },
      {
        text: "pH ajustado",
        align: "center",
        value: "adjustedPh",
        sortable: false,
      },
      {
        text: "Fecha de envasado",
        align: "center",
        value: "packingDate",
        sortable: false,
      },
      {
        text: "Litros envasados",
        align: "center",
        value: "litersPT",
        sortable: false,
      },
      {
        text: "Estatus",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Acciones",
        align: "center",
        value: "actions",
        sortable: false,
      },
    ],
    refeeds: [],
    page: 1,
    fetchingData: false,
    numPages: 1,
    refeed: null,
    averageDrums: 0,
    gapDrums: 0,
    isValid: null,
    stockeRemoved: null,
    currentMiniReactorTab: 0,
    showInitialPhAdvice: false,
    showAdjustedPhAdvice: false,
    currentMiniReactorTabAdjusted: 0,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("lotes", ["loteSelected"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    //validate step to go to correct step
    if (this.loteSelected.productionState == "BATCH_CREATED") {
      this.stepper = 1;
    } else if (this.loteSelected.productionState == "INOCULATE") {
      this.stepper = 2;
    } else if (this.loteSelected.productionState == "SEED") {
      this.stepper = 3;
    } else if (this.loteSelected.productionState == "FERMENTATION") {
      this.stepper = 4;
    } else {
      this.stepper = 4;
    }
    if (this.loteSelected.isValidationCepario) {
      this.setPanel = null;
    }
    this.setRefeeds();
  },
  methods: {
    getFieldRef(fieldName) {
      return `fieldRef_${fieldName}`;
    },
    ...mapActions("lotes", [
      "saveDataPreinoculate",
      "startInoculate",
      "startSeed",
      "saveSeed",
      "endSeed",
      "saveSeedFinalStage",
      "finishSeedFinalStage",
      "goTo3LValidation",
      "goTo5LValidation",
      "save5LValidation",
      "saveFermentationReeactorSimple",
      "endFermentationReeactorSimple",
      "finishLote",
      "addRefeed",
      "saveFeedableData",
      "endFeedable",
      "endDrumsRegister",
      "startSeedFeedable",
      "deleteLote",
      "discardLote",
      "goToFeedable",
      "saveMRFirstStep",
      "saveMRPhFlaskFirstStep",
      "saveFeedablePT",
      "undoPreinoculate",
      "undoStartInoculate",
      "undoStartSeed",
      "undoFinishSeedFinalStage",
      "undoSaveMRFirstStep",
      "undoEndFermentationReeactorSimple",
      "finishLoteSave",
    ]),
    ...mapActions("bioactives", ["getMorphology"]),
    ...mapMutations("lotes", ["SET_LOTE_SELECTED", "SET_FETCH_LOTES_LIST"]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    closeModal() {
      this.show = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    validationMultiple(name) {
      return requiredMultiple(name);
    },
    validationNumber(name) {
      return numberValidation({ min: 1, name: name, required: true });
    },
    validationNumberMin(name, min) {
      return numberValidation({ min: 0, name: name, required: true });
    },
    validationConditional(name, flag) {
      if (flag) {
        return [() => true];
      } else {
        return requiredValidation(name);
      }
    },
    validationConditionalF(name, flag) {
      if (flag) {
        return [() => true];
      } else {
        return requiredFValidation(name);
      }
    },

    dateFormatShort(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY")}`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    async saveDataPreinoculateRequest() {
      if (this.$refs.formPreinoculate.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            date: this.loteSelected.preinoculateStartDate,
            flaskQtyStart: this.loteSelected.flaskQtyStart,
          };
          let response = await this.saveDataPreinoculate(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.stepper = 2;
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al pasar a validar`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al pasar a validar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async goToInoculate() {
      if (this.$refs.formInoculate.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            inoculateDate: this.loteSelected.inoculateDate,
            jarsQty: this.loteSelected.jarsQty,
          };
          let response = await this.startInoculate(payload);
          if (response) {
            // this.stepper = 2;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.stepper = 3;
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Inóculo iniciado!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar preinóculo`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al finalizar preinóculo`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async startSeedRequest() {
      if (this.$refs.formSeedStart.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            seedDate: this.loteSelected.seedDate,
            jarsSeedQty: this.loteSelected.jarsSeedQty,
            jarType: "BB13",
          };

          payload.seedIsFeedable = false;

          let response = await this.startSeed(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async startSeedFeedableRequest() {
      if (this.$refs.formFeedableSeedStart.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            seedDateFeedable: this.loteSelected.seedDateFeedable,
            jarsSeedFeedableQty: this.loteSelected.jarsSeedFeedableQty,
          };

          let response = await this.startSeedFeedable(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async saveSeedFinalStageRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          isFeedable: this.loteSelected.isFeedable,
          productionType: this.loteSelected.productionType,
          reactor: this.loteSelected.reactor,
        };
        let response = await this.saveSeedFinalStage(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async finishSeedFinalStageRequest() {
      if (this.$refs.formSeedEnd.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            isFeedable: this.loteSelected.isFeedable,
            productionType: this.loteSelected.productionType,
            reactor: this.loteSelected.reactor,
          };
          let response = await this.finishSeedFinalStage(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.stepper = 4;
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async goTo3LValidationRequest() {
      if (this.$refs.formDrum3L.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            fermentationDrum3LDate: this.loteSelected.fermentationDrum3LDate,
            drumsQty: this.loteSelected.drumsQty,
          };
          let response = await this.goTo3LValidation(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async goTo5LValidationRequest() {
      if (this.$refs.formDrum5L.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            fermentationDrum5LDate: this.loteSelected.fermentationDrum5LDate,
            drumsQty5L: this.loteSelected.drumsQty5L,
          };
          let response = await this.goTo5LValidation(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.$swal({
              icon: "success",
              title: `Lote finalizado`,
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async save5LValidationRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          drum5L: this.sampleFermentation5L,
          areaThereColiforms: this.loteSelected.areaThereColiforms,
        };
        let response = await this.save5LValidation(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveFermentationReeactorSimpleRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          reactorFlushDate: this.loteSelected.reactorFlushDate,
          reactorSterilizationDate: this.loteSelected.reactorSterilizationDate,
          reactorInoculationSeedDate:
            this.loteSelected.reactorInoculationSeedDate,
          reactorFermentation: this.loteSelected.reactorFermentation,
          reactorSterilization2Date:
            this.loteSelected.reactorSterilization2Date,
        };
        let response = await this.saveFermentationReeactorSimple(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada!!",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async endFermentationReeactorSimpleRequest() {
      if (this.$refs.formReactorDates.validate()) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            reactorFlushDate: this.loteSelected.reactorFlushDate,
            reactorSterilizationDate:
              this.loteSelected.reactorSterilizationDate,
            reactorInoculationSeedDate:
              this.loteSelected.reactorInoculationSeedDate,
            reactorFermentation: this.loteSelected.reactorFermentation,
            reactorSterilization2Date:
              this.loteSelected.reactorSterilization2Date,
          };
          let response = await this.endFermentationReeactorSimple(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async finishLoteRequest() {
      let flag = true;
      if (this.$refs.form_finish_react_single) {
        flag = this.$refs.form_finish_react_single.validate();
      }
      if (flag) {
        try {
          this.showAdjustedPhAdvice = false;
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
            packingDate: this.loteSelected.packingDate,
            drumsQty: this.loteSelected.drumsQty,
            flask: this.loteSelected.miniReactorFlasks,
          };
          let response = await this.finishLote(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (response.lote.isFeedable) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Validación finalizada!!",
                timeout: 3500,
              });
            } else {
              this.$swal({
                icon: "success",
                title: `Lote finalizado!!`,
                showConfirmButton: false,
                timer: 2000,
              });
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar validación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al finalizar validación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async handleFinishLoteSave() {
      try {
        this.showAdjustedPhAdvice = false;
        let payload = {
          loteId: this.loteSelected._id,
          packingDate: this.loteSelected.packingDate,
          drumsQty: this.loteSelected.drumsQty,
          initialPhReactor: this.loteSelected.initialPhReactor,
          endPhReactor: this.loteSelected.endPhReactor,
          mlAdjustmentReactor: this.loteSelected.mlAdjustmentReactor,
        };
        let response = await this.finishLoteSave(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardadar información`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardadar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async goToFeedableRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.goToFeedable(payload);
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);

        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Fermentación finalizada!!",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar validación`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async addRefeedRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
        };
        let response = await this.addRefeed(payload);
        if (response) {
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.setRefeeds();
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Realimentacioón creada ",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al crear realimentación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al crear realimentación`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    setRefeeds() {
      if (this.loteSelected && this.loteSelected.refeedables) {
        this.refeeds = this.loteSelected.refeedables;
      }
    },
    async setRefeed(item) {
      this.refeed = item;
    },
    unSetRefeed() {
      this.refeed = null;
    },
    async dicardLote(reasonForRejection) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          reasonContamination: reasonForRejection,
        };
        let response = await this.discardLote(payload);
        if (!response) throw response;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.$swal({
          icon: "success",
          title: `Se ha desechado el lote exitosamente`,
          showConfirmButton: false,
          timer: 2000,
        });
        this.show = false;
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al desechar el lote`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveFeedableDataRequest(isDone) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          refeed: this.refeed,
          isDone: isDone,
        };
        let validation = true;
        if (isDone) {
          validation = this.$refs.formRefeed.validate();
        }
        if (validation) {
          let response = await this.saveFeedableData(payload);
          if (response) {
            this.refeed = response.refeed;
            this.refeeds = response.lote.refeedables;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async saveFeedablePTRequest() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          refeed: this.refeed,
        };

        if (this.$refs.packingFormRefeed.validate()) {
          let response = await this.saveFeedablePT(payload);
          if (response) {
            this.refeed = response.refeed;
            this.refeeds = response.lote.refeedables;
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Información guardada!!",
              timeout: 3500,
            });
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al guardar información`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar información`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async endFeedableRequest() {
      try {
        let flag = true;
        if (this.loteSelected.refeedables.length > 0) {
          for (let item of this.loteSelected.refeedables) {
            if (item.validations.isApproved == true) {
              if (!item.isDone) {
                flag = false;
              }
              if (!item.isDoneValidations) {
                flag = false;
              }
            }
            if (!flag) {
              this.$swal({
                icon: "info",
                title: `Finaliza datos de producción o calidad en realimentación`,
                showConfirmButton: false,
                timer: 3000,
              });
              break;
            }
          }
        } else {
          flag = false;
          this.$swal({
            icon: "info",
            title: `Agrega por lo menos una realimentación`,
            showConfirmButton: false,
            timer: 3000,
          });
        }
        if (flag) {
          let payload = {
            loteId: this.loteSelected._id,
            user: this.user._id,
          };
          let response = await this.endFeedable(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (response.lote.isFeedable) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "realimentación finalizada!!",
                timeout: 3500,
              });
            } else {
              this.$swal({
                icon: "success",
                title: `Lote finalizado!!`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.show = false;
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar validación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar validación`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async endDrumsRegisterRequest(isDone) {
      try {
        let payload = {
          loteId: this.loteSelected._id,
          user: this.user._id,
          drums: this.loteSelected.drums,
          isDone: isDone,
        };
        let validation = true;
        if (isDone) {
          validation = this.$refs.formDrumsRegister.validate();
        }
        if (validation) {
          let response = await this.endDrumsRegister(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            if (isDone) {
              this.$swal({
                icon: "success",
                title: `Registro finalizado!!`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.show = false;
            } else {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Información guardada!!!",
                timeout: 3500,
              });
            }
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al finalizar registro`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al finalizar registro`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async confirmDeleteLote(obj) {
      if (obj) {
        try {
          let payload = {
            loteId: this.loteSelected._id,
            reasonContamination: obj.value,
            user: this.user._id,
          };
          let response = await this.deleteLote(payload);
          if (response) {
            this.SET_LOTE_SELECTED(response.lote);
            this.SET_FETCH_LOTES_LIST(true);
            this.$swal({
              icon: "success",
              title: "Se descarto lote exitosamente!!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.show = false;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al descartar lote por contaminación`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al descartar lote por contaminación`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      }
    },
    async endMRFirstStep() {
      try {
        if (this.$refs.form_first_rm.validate()) {
          let payload = {
            miniReactorStartDate: this.loteSelected.miniReactorStartDate,
            flaskQuantity: this.loteSelected.miniReactorQuantity,
            loteId: this.loteSelected._id,
          };
          let response = await this.saveMRFirstStep(payload);
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Acción exitosa",
            timeout: 3500,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async savePhInitial(isDone) {
      try {
        let validated = true;
        if (isDone) {
          for (const flask of this.loteSelected.miniReactorFlasks) {
            if (!flask.initialPh) {
              validated = false;
              break;
            }
            if (!flask.endPh) {
              validated = false;
              break;
            }
          }
        }
        if (validated) {
          this.showInitialPhAdvice = false;
          let payload = {
            flasks: this.loteSelected.miniReactorFlasks,
            loteId: this.loteSelected._id,
            isDone: isDone,
          };
          let response = await this.saveMRPhFlaskFirstStep(payload);
          this.SET_LOTE_SELECTED(response.lote);
          this.SET_FETCH_LOTES_LIST(true);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Acción exitosa",
            timeout: 3500,
          });
        } else {
          this.showInitialPhAdvice = true;
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    getStatus(status) {
      if (status == "NOT_STARTED") {
        return "Sin iniciar";
      } else if (status == "IN_PROGRESS") {
        return "En proceso";
      } else if (status == "VALIDATED") {
        return "Validado por calidad";
      } else if (status == "FINISHED") {
        return "Producto terminado";
      }
    },
    async handleUndoPreinoculate() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoPreinoculate(payload);
        this.stepper = 1;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoInoculate() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoStartInoculate(payload);
        this.stepper = 2;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handlePreSeed() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoStartSeed(payload);
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoSeed() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoFinishSeedFinalStage(payload);
        this.stepper = 3;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoMrFirstStep() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoSaveMRFirstStep(payload);
        this.stepper = 4;
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async handleUndoEndFermentationReeactorSimple() {
      try {
        let payload = {
          loteId: this.loteSelected._id,
        };
        let response = await this.undoEndFermentationReeactorSimple(payload);
        this.SET_LOTE_SELECTED(response.lote);
        this.SET_FETCH_LOTES_LIST(true);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Acción exitosa",
          timeout: 3500,
        });
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Error: ${error.message}`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
  watch: {
    "loteSelected.drums": {
      handler: function (val) {
        this.averageDrums = 0;
        this.gapDrums = 0;
        if (val.length > 0) {
          for (let item of val) {
            if (
              item.value != null &&
              item.value != undefined &&
              item.value.length > 0
            ) {
              this.averageDrums += parseFloat(item.value);
            }
          }
          this.averageDrums = (this.averageDrums / val.length).toFixed(2);
          this.gapDrums = 5140.0 - this.averageDrums;
          let minWeight = 4980;
          let maxWeight = 5500;
          this.isValid =
            this.averageDrums >= minWeight && this.averageDrums <= maxWeight;
          this.gapDrums = this.gapDrums.toFixed(2);
        }
      },
      deep: true,
    },
    "loteSelected.flasks": {
      handler: function (val) {
        this.showAdviceMFPreinoculate = false;
      },
      deep: true,
    },
    "loteSelected.jars": {
      handler: function (val) {
        this.showMFAdviceInoculate = false;
      },
      deep: true,
    },
    "loteSelected.jarsSeed": {
      handler: function (val) {
        this.showAdviceMFSeed = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.scroll-row {
  max-height: 200px;
  /* Altura máxima de la fila */
  overflow-y: auto;
  /* Agrega un scroll vertical */
}
</style>
